












import Vue from "vue";
import Component from "vue-class-component";
import ReservationsTable from "@/components/tables/reservations/reservations-table.vue";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import { ReservationsTableInitialFilters } from "@/components/tables/reservations/reservation-table-types";
import DataTable from "@/components/data/data-table.vue";
import { DateTime } from "luxon";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "reservations",
    components: { ReservationsTable, Page, PageHeader, DataTable },
})
export default class Reservations extends Vue {
    get filters(): ReservationsTableInitialFilters {
        return {
            customerId: parseInt(this.$route.params.customerId),
            officeId: parseInt(this.$route.params.officeId),
            dates: [DateTime.local().minus({ months: 1 }), DateTime.local()],
        };
    }
}
